import _ from "lodash";

export const oktaAuthenticate = async (authClient) => {
  const authClientResponse = await authClient.idx.authenticate();
};

export const oktaProceed = async (authClient, username) => {
  const oktaProceedResponse = await authClient.idx.proceed({
    username: username,
  });
  return oktaProceedResponse;
};

export const oktaProceedAuthenticator = async (authClient) => {
  const oktaProceedAuthenticatorResponse = await authClient.idx.proceed({
    authenticator: "phone_number",
  });
};

export const oktaTriggerSMS = async (authClient) => {
  const oktaTriggerSMSResponse = await authClient.idx.proceed({
    methodType: "sms",
  });
  return {
    status: oktaTriggerSMSResponse?.status,
    messages: oktaTriggerSMSResponse?.messages,
  };
};

export const oktaVerifyOtp = async (authClient, verificationOtp) => {
  const oktaVerifyOtpResponse = await authClient.idx.proceed({
    verificationCode: verificationOtp,
  });
  return {
    status: oktaVerifyOtpResponse?.status,
    tokens: oktaVerifyOtpResponse?.tokens,
    nextStep: oktaVerifyOtpResponse?.nextStep?.inputs,
  };
};

export const getQuoteInformationFromOkta = (oktaProceedResponse) => {
  const nextStepDetails = _.first(oktaProceedResponse?.nextStep?.inputs);
  /* Ideal journey it should be "authenticator", however if the okta session exist then it will directly go to the SMS steps,
     So we need to check for "methodType" as well
  */
  const nextStepProcess = nextStepDetails.name;
  if (nextStepProcess === "authenticator" || nextStepProcess === "methodType") {
    // "authenticator" state means that the quote is valid and it is able to go to next step of authentication via SMS
    const mobileNumber = extractPhoneNumberByMethod(oktaProceedResponse, "sms");
    return {
      quoteValid: true,
      mobileNumber: mobileNumber,
    };
  } else {
    return {
      quoteValid: false,
      mobileNumber: null,
    };
  }
};

const extractPhoneNumberByMethod = (data, methodType) => {
  const matchingEntry = _.find(
    data.context.authenticatorEnrollments.value,
    (entry) => {
      const methods = entry.methods;
      return methods && methods.some((method) => method.type === methodType);
    }
  );
  if (matchingEntry) {
    return _.get(matchingEntry, "profile.phoneNumber", "");
  } else {
    return "";
  }
};

export const getOktaSmsTriggerErrorCode = (messages) => {
  const oktaErrorCode = _.first(messages);
  return oktaErrorCode?.i18n?.key;
};
